<app-banner [heading]="'SOCIAL RESPONSIBILITY'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">
<section id="events" class="events">
      <div class="container" data-aos="fade-up">

        
		 <div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/oldagehome/oldagehome (1).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/oldagehome/oldagehome (2).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div><div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/oldagehome/oldagehome (3).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/oldagehome/oldagehome (4).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/oldagehome/oldagehome (5).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
				<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/oldagehome/oldagehome (6).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		</div>		
		<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(1).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(2).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(3).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(4).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(5).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(6).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(7).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/gallery/activity10/pic(8).jpg" alt="best school in kurukshetra">
              </div>
             
            </div>
	    </div>
			
	

          
		</div>
      </div>
	</section><!-- End About Section -->
	
  </div></div></section></main>